module.exports = __webpack_public_path__ + "img/388d67c493454b80a7c64cd624d10332_mergeImage.50645801.png";